import { render, staticRenderFns } from "./IndagineEpidemiologicaListeriosiEditComponent.vue?vue&type=template&id=40413968"
import script from "./IndagineEpidemiologicaListeriosiEditComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaListeriosiEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports